import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { WidgetState } from 'src/app/widget-auth/state/widget.state';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { ViewActions } from 'src/app/view/state/view.actions';
import { AnalyticsService } from 'src/app/shared/analytics.service';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app-widget.component.html',
  styleUrls: ['./app-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppWidgetComponent implements OnInit, OnDestroy {
  @Select(WidgetState.getInputEnabled)
  inputEnabled$: Observable<boolean>;
  
  title = 'Biodigital Human';
  ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {
    analyticsService.init(environment.googleAnalyticsId);
  }

  ngOnInit() {
    this.initPageAnalytics();
    this.initInputObserver();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  initInputObserver() {
    this.inputEnabled$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(enabled => {
      this.store.dispatch(new ViewActions.SetInputEnabled(enabled));
    });
  }

  initPageAnalytics() {
    // log initial page view
    // this.analyticsService.logPageView(this.router.url);

    // log subsequent in app route changes (i.e., /error)
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.analyticsService.logPageView(url);
      });
  }
}
